import { defineComponent, ref } from 'vue'
import { find, sortBy } from 'lodash'

import { BucketAPIHelper } from '@/lib/BucketAPIHelper'
import ImageZoomOverlay from '@/components/UI/ImageZoomOverlay/ImageZoomOverlay.vue'

export default defineComponent({
    name: 'HomePage',
    components: {
        ImageZoomOverlay
    },
    setup () {
        const fetchingPatients = ref(false)
        const patients = ref<any[]>([])
        const patient = ref<any>(null)
        const lesion = ref<any>(null)
        const exam = ref<any>(null)
        const imageSelected = ref(false)
        const imageURLSelected = ref('')
        const showSnackbar = ref(false)
        const snackbarColor = ref('error')
        const snackbarMessage = ref('')

        function notify (message: string, color: string) {
            showSnackbar.value = true
            snackbarColor.value = color
            snackbarMessage.value = message
        }

        function getPatients () {
            fetchingPatients.value = true

            BucketAPIHelper.getPatients()
                .then((response) => patients.value = response.data)
                .catch(err => {
                    if (err.response && err.response.status === 401) {
                        window.location.href = '/authentication'
                        notify('Unauthorized access. Please log in.', 'error')
                    } else {
                        notify(err, 'error')
                    }
                })
                .finally(() => fetchingPatients.value = false)
        }

        getPatients()

        return {
            fetchingPatients,
            patients,
            patient,
            lesion,
            exam,
            imageSelected,
            imageURLSelected,
            notify,
            showSnackbar,
            snackbarColor,
            snackbarMessage,
            sortBy
        }
    },
    methods: {
        fetchCurrentPatientURLs () {
            this.fetchingPatients = true

            BucketAPIHelper.getPatientMediasURLs(this.patient.id)
                .then((response: any) => {
                    this.patient = response.data
                    this.lesion = find(this.patient.lesions, ['id', this.lesion.id])
                    this.exam = find(this.lesion.exams, ['id', this.exam.id])
                })
                .catch(() => this.notify('Failed to fetch patient media URLs', 'error'))
                .finally(() => this.fetchingPatients = false)
        },
        formatTime (time: string) {
            const hours = time.substring(0, 2)
            const minutes = time.substring(2, 4)
            return `${hours}:${minutes}`
        },
        selectImage (imageURL: string) {
            this.imageSelected = true
            this.imageURLSelected = imageURL
        },
        selectPatient (patient: any) {
            this.patient = patient
            this.lesion = sortBy(this.patient.lesions, ['id'])[0]
            this.exam = sortBy(this.lesion.exams, ['id'])[0]

            const firstAcquisition = this.exam.acquisitions[0]
            const areMediasURLLoaded = firstAcquisition && firstAcquisition.medias.thumbnailURL
            if (!areMediasURLLoaded) this.fetchCurrentPatientURLs()
        },
        selectLesion (lesion: any) {
            this.lesion = lesion
            this.exam = sortBy(this.lesion.exams, ['id'])[0]
        }
    }
})